import {Accordion, AccordionDetails, AccordionSummary, Chip, styled} from '@mui/material';
import {
	CustomAccordionDetailsProps,
	CustomAccordionProps,
	CustomAccordionSummaryProps,
} from './types';

export const AccordionHeader = styled('div')`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const CustomAccordion = styled(Accordion)<CustomAccordionProps>`
	.MuiAccordionSummary-root {
		cursor: ${({$cursor}) => `${$cursor} !important`};
	}

	&.MuiAccordion-root {
		background-color: ${({$removeBgColor, theme}) =>
			$removeBgColor ? 'transparent' : theme.colors.light.background.paper};

		box-shadow: none;
		@media (min-width: ${({theme}) => theme.breakpoints.values.md}px) {
			border-radius: 0px 0px 8px 8px;
		}
	}
	.Mui-expanded {
		margin: 0px;
	}
`;

const CustomAccordionSummary = styled(AccordionSummary)<CustomAccordionSummaryProps>`
	&.MuiAccordionSummary-root {
		background-color: ${({$variant, theme}) =>
			$variant === 'pending'
				? theme.colors.light.primary['10Percent']
				: theme.colors.light.success['08Percent']};

		border-bottom: 1px solid
			${({$variant, theme}) =>
				$variant === 'pending'
					? theme.colors.light.primary.dark
					: theme.colors.light.success.border};
		padding: 0px 16px;
	}
`;

const CustomAccordionDetails = styled(AccordionDetails)<CustomAccordionDetailsProps>`
	&.MuiAccordionDetails-root {
		padding: 16px;

		${({theme}) => theme.breakpoints.up('md')} {
			padding: ${props => (props.$noPadding ? '16px 0px 0px' : '16px')};
		}
	}
`;

const CustomChip = styled(Chip)`
	margin-right: 8px;
`;

export {CustomAccordion, CustomAccordionSummary, CustomAccordionDetails, CustomChip};
